module.exports = __webpack_public_path__ + "media/packs/order-bump-25fc3fd7828ce38ce8690134c5eb3cf3.svg";